import {
  usePropertyServicePropertyRisksList,
  usePropertyServicePropertyRisksListKey
} from '@insurance/api/queries'
import { useValidationsField } from '@insurance/hooks'
import { useQueryClient } from '@tanstack/react-query'
import { Form, Select, SelectProps } from 'antd'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { CategoryType } from './type'
import { formProps } from './utils'

type Props = {
  fieldKey: number
  category: CategoryType
} & SelectProps

export const ItemRisksSelect = ({ fieldKey, category, ...props }: Props) => {
  const { t } = useTranslation()
  const { required } = useValidationsField()
  const { ItemRisksProps, ItemCategoryProps, itemsKey } = formProps(t)
  const queryClient = useQueryClient()

  const { data, isLoading } = usePropertyServicePropertyRisksList(
    { category },
    [category],
    {
      enabled: !!category,
      select: (data) => data.filter((item) => item.type?.value !== 'full')
    }
  )

  const isFetching = queryClient.isFetching({
    queryKey: [usePropertyServicePropertyRisksListKey, [{ category }]]
  })

  const selectOptions = useMemo(() => {
    return data?.map((item) => ({
      label: item.type?.label,
      value: item?.id
    }))
  }, [data])

  return (
    <Form.Item
      {...ItemRisksProps}
      name={[fieldKey, ItemRisksProps.name]}
      rules={[required]}
      dependencies={[itemsKey.name, fieldKey, ItemCategoryProps.name]}
    >
      <Select
        placeholder={t('select_risks')}
        options={selectOptions}
        loading={isLoading || !!isFetching}
        maxTagCount={1}
        mode="multiple"
        className="select-min-width"
        {...props}
      />
    </Form.Item>
  )
}
